import PropTypes from "prop-types";
import React from "react";
import accounting from "accounting";
import { compose, mapProps } from "recompose";

const enhancedDonutChartProps = compose(
  mapProps(({ sizeRatio = 1, relativeCircumference = 100, ...props }) => ({
    //change to 0.75 to see it going haywire
    ...props,
    width: `${accounting.toFixed(80 / sizeRatio, 2)}%`,
    height: `${accounting.toFixed(80 / sizeRatio, 2)}%`,
    strokeWidth: Math.floor(accounting.unformat(16 * sizeRatio)), // based on sizeRatio to keep the chart size consistent
    radius: accounting.unformat(relativeCircumference / (2 * Math.PI)),
  }))
);

const crypto = window.crypto || window.msCrypto;

const DonutChart = (
  {
    segments = [],
    classNames: { hole, ring } = {},
    maxX = 40,
    maxY = 40,
    width,
    height,
    strokeWidth,
    radius,
    startOffset = 0, //starts at 3 o'clock going counter clock-wise. 25 to start at 0 o'clock, 50 at 9 o'clock and so on
  } // here be dragons - // to fit in with design, I used < 100% radii (sizeRatio < 1) for the segments // which gave a 'working' impression. That was wrong as radii have to be 100% for proportionate segments. At 100% ratio, the donut centre became too wide // so here we make a smaller circle with bigger stroke to overflow out of // SVG boundary, which calls for different styling at parent container to position the SVG accordingly
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${maxX} ${maxY}`}
    preserveAspectRatio="xMidYMin slice"
    className="cxa-donut"
  >
    <circle className="cxa-donut__hole" cx={maxX / 2} cy={maxY / 2} r={radius} />
    {/* whole ring - to help check layout if something is off */}
    <circle
      className="cxa-donut__ring cxa-donut__colour--default"
      cx={maxX / 2}
      cy={maxY / 2}
      r={radius}
      strokeWidth={strokeWidth}
    />
    {/* each segment of the chart, up to 4 colours supported
        add more in global $chart-colours but better off using another chart */}
    {segments.map(
      ({ percentage = 0, name = `donutchart-segment-${crypto.randomUUID()}` }, i, arr) =>
        percentage > 0 && (
          <circle
            key={name}
            className={`cxa-donut__segment cxa-donut__colour--${i}`}
            cx={maxX / 2}
            cy={maxY / 2}
            r={radius}
            strokeWidth={strokeWidth}
            strokeDasharray={`${percentage} ${100 - percentage}`}
            strokeDashoffset={
              i === 0
                ? startOffset
                : 100 - arr.slice(0, i).reduce((prev, e) => prev + e.percentage, 0) + startOffset
            }
          />
        )
    )}
  </svg>
);

DonutChart.propTypes = {
  segments: PropTypes.array,
  classNames: PropTypes.object,
  relativeCircumference: PropTypes.number,
  radius: PropTypes.number,
  strokeWidth: PropTypes.number,
  maxX: PropTypes.number,
  maxY: PropTypes.number,
  sizeRatio: PropTypes.number,
  startOffset: PropTypes.number,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default enhancedDonutChartProps(DonutChart);



// WEBPACK FOOTER //
// ./casper/sass/components/donut-chart/donut-chart.js